import { PaletteMode } from "@mui/material/styles";

export const mindsetSegmentColors = [
  "#82E1F2",
  "#70c9f0",
  "#72b0e7",
  "#8294d5",
  "#9476b8",
  "#9e5892",
  "#9c3c65",
];

export const mindsetSegmentPalette = Object.fromEntries(
  mindsetSegmentColors.map((c, i) => [`segment${i}`, { main: c }])
) as Record<`segment${number}`, { main: string }>;


/*
  Bupa
 */

export const bupaTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#0079C8",
      light: "#80d5ff",
      dark: "#0657a6",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0079C8",
      light: "#80d5ff",
      dark: "#0657a6",
      contrastText: "#ffffff",
    },
    info: {
      main: "#0D1846",
      light: "#6a769f",
      dark: "#0D1846",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F2F1F1",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#F2F1F1",
    gradient: [
      "#cfe4ff",
      "#a8c8f1",
      "#80ade4",
      "#5493d6",
      "#0079c8"
    ],
    score: {
      main: "#F2F1F1",
      light: "#0079c8",
      dark: "#f3002c",
      contrastText: "#000000",
    },
    segments: mindsetSegmentColors,
    ...mindsetSegmentPalette,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 754,
      md: 1028,
      lg: 1200,
      xl: 1448,
    }
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#000000",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}
